import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';

const actions = {
    getPrepaymentBalance: {
        method: 'GET',
        url: `${BASE_PATH_API}/prepayments/:unitAgreementId/balance`
    },
    isPrepaymentValidForGlAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/prepayments/glAccountValidatorCommand`
    },
    createPrepaymentSettings: {
        method: 'POST',
        url: `${BASE_PATH_API}/prepayments/settings`
    },
    updatePrepaymentSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/prepayments/:id/settings`
    },
    deletePrepaymentSettings: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/prepayments/settings/:id`
    },
    getPrepaymentSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/prepayments/settings`
    },
    isPrepaymentValidForUnitAgreement: {
        method: 'GET',
        url: `${BASE_PATH_API}/prepayments/unitAgreementValidatorCommand`
    },
    getApplicantPrepaymentBalance: {
        method: 'GET',
        url: `${BASE_PATH_API}/prepayments/:applicantId/applicant/balance`
    }
};

export function PrepaymentsApi() {
    return createActions(actions);
}
